/** Pixen Intrigue — marketing copy overrides. Courtly-fae voice. Only flavor-bearing keys; generic UI strings are inherited. */
export const marketingPixEn = {
  // FreeMagnetPage
  'marketing.free.seo.description':
    'Get the free Pixen Intrigue Quickstart — the rules and a one-shot you can run tonight. Enter the Court.',
  'marketing.free.heading': 'Enter the Court — free',
  'marketing.free.quickstartName': 'Pixen Intrigue Quickstart',
  'marketing.free.benefit.livingWorld.title': 'A living Court',

  // LeadCaptureForm
  'marketing.leadForm.privacyNote':
    'No spam — just the Quickstart and the occasional dispatch from the Court. Unsubscribe anytime.',
} as const
